import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

type PageHeaderCreateActionProps = Readonly<{
  label: string;
  state?: unknown;
  temporarilyDisabled?: boolean;
}>;

export function PageHeaderCreateAction({
  label,
  state,
  temporarilyDisabled = false,
}: PageHeaderCreateActionProps): React.JSX.Element {
  return (
    <Link
      aria-label={label}
      aria-disabled={temporarilyDisabled || undefined}
      className={`primary-button page-header-create-action${temporarilyDisabled ? " is-disabled" : ""}`}
      onClick={(event) => {
        if (temporarilyDisabled) event.preventDefault();
      }}
      tabIndex={temporarilyDisabled ? -1 : undefined}
      to="/activities/new"
      state={state}
    >
      <Plus aria-hidden="true" size={17} />
      {label}
    </Link>
  );
}
